import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FlightResponse } from 'src/app/flight/models/FlightResponse';

import { assign } from 'lodash';
import { FlightSegmentSch, OTAAirScheduleResponse, OriginDestinationOption } from '../models/OTAAirScheduleResponse';

@Component({
    selector: 'app-card-flight',
    templateUrl: './card-flight.component.html',
    styleUrls: ['./card-flight.component.scss'],
    standalone: false
})
export class CardFlightComponent {

  @Input() flight: OriginDestinationOption;
  @Input() position: number;
  @Input() isMultiple: boolean;

  @Output() toggle: EventEmitter<any> = new EventEmitter();

  @ViewChild('itineraryCollapase') itineraryCollapase: ElementRef;

  toggleItinerary(): void {
    this.itineraryCollapase.nativeElement.classList.toggle('itinerary-collapase_arrow');
    this.itineraryCollapase.nativeElement.classList.toggle('itinerary-collapase_arrow-opened');
    this.toggle.emit(this.position);
  }
}
